import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['p', 'br', 'a', 'b', 'strong'];
const ALLOWED_ATTRIBUTES = ['href'];

// Keep only the rich-text features supported by the event editor and make links safe.
export function sanitizeEventRichText(html = '') {
	const decoder = document.createElement('textarea');
	decoder.innerHTML = String(html || '');
	const sanitizedHtml = DOMPurify.sanitize(decoder.value, {
		ALLOWED_TAGS,
		ALLOWED_ATTR:    ALLOWED_ATTRIBUTES,
		ALLOW_ARIA_ATTR: false,
		ALLOW_DATA_ATTR: false,
	});
	const documentNode = new DOMParser().parseFromString(sanitizedHtml, 'text/html');
	documentNode.body.querySelectorAll('a[href]').forEach((link) => {
		link.setAttribute('target', '_blank');
		link.setAttribute('rel', 'noopener noreferrer');
	});

	return documentNode.body.innerHTML;
}
